import React from 'react';
import { Chip } from '@mui/material';
import { ApprovalBadge, BadgeLabel } from '../types';

const FAVORABLE_COLORS = { bg: '#e8f5e9', text: '#2e7d32' };
const UNFAVORABLE_COLORS = { bg: '#fff9c4', text: '#f57f17' };

const BADGE_LABELS: Record<BadgeLabel, string> = {
  highest: 'Highest',
  lowest: 'Lowest',
  fewest: 'Fewest',
  most: 'Most',
};

interface RankBadgeProps {
  badge: ApprovalBadge;
}

export const RankBadge: React.FC<RankBadgeProps> = ({ badge }) => {
  const colors = badge.favorable ? FAVORABLE_COLORS : UNFAVORABLE_COLORS;

  return (
    <Chip
      label={BADGE_LABELS[badge.label]}
      size="small"
      sx={{
        backgroundColor: colors.bg,
        color: colors.text,
        fontWeight: 600,
        fontSize: '0.7rem',
        height: 22,
        ml: 1,
      }}
    />
  );
};
